webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(333);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(336);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _angular = __webpack_require__(371);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(373);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularUiRouter = __webpack_require__(375);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _ngAdmin = __webpack_require__(456);
	
	var _ngAdmin2 = _interopRequireDefault(_ngAdmin);
	
	var _app = __webpack_require__(739);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _jwtDecode = __webpack_require__(746);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _helpers = __webpack_require__(749);
	
	var _moment = __webpack_require__(750);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(887);
	
	var _common = __webpack_require__(889);
	
	var _content = __webpack_require__(890);
	
	var _notification = __webpack_require__(891);
	
	var _security = __webpack_require__(892);
	
	var _ezyImpersonateButton = __webpack_require__(893);
	
	var _ezyImpersonateButton2 = _interopRequireDefault(_ezyImpersonateButton);
	
	var _ezyManageSubscription = __webpack_require__(895);
	
	var _ezyManageSubscription2 = _interopRequireDefault(_ezyManageSubscription);
	
	var _ezyBoolTimestampField = __webpack_require__(896);
	
	var _ezyBoolTimestampField2 = _interopRequireDefault(_ezyBoolTimestampField);
	
	var _ezyDisableStoryButton = __webpack_require__(897);
	
	var _ezyDisableStoryButton2 = _interopRequireDefault(_ezyDisableStoryButton);
	
	var _ezyLogsTable = __webpack_require__(898);
	
	var _ezyLogsTable2 = _interopRequireDefault(_ezyLogsTable);
	
	var _dashboard = __webpack_require__(900);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//noqa
	var initSubscriptionUser = function initSubscriptionUser(nga) {
	  var subscription = nga.entity('user_subscription');
	  var subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')).remoteComplete(true, {
	    searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    }
	  });
	  var userField = nga.field('user_id', 'reference').label('Email').targetEntity(nga.entity('person')).targetField(nga.field('email')).remoteComplete(true, {
	    searchQuery: function searchQuery(search) {
	      return { email__icontains: search };
	    }
	  });
	  subscription.listView().title('Subscription user list').fields([nga.field('id'), subscriptionField, userField]).filters([subscriptionField.pinned(true), userField.pinned(true)]).actions(['create', 'filter']);
	
	  subscription.creationView().title('Create subscription').fields([subscriptionField, userField, nga.field('frontend_settings', 'json')]);
	  subscription.editionView().title('Edit subscription').fields(subscription.creationView().fields()).actions(['list']);
	
	  return subscription;
	};
	
	// ------------ entities ------------------
	
	// HTML
	
	
	var initStreamFeatures = function initStreamFeatures(nga) {
	  var streamFeature = nga.entity('stream_feature');
	  var streamField = nga.field('stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream')).targetField(nga.field('name')).remoteComplete(true, {
	    searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    }
	  });
	  var subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')).remoteComplete(true, {
	    searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    }
	  });
	  streamFeature.listView().title('Stream features').fields([nga.field('id'), streamField, subscriptionField, nga.field('feature_type')]).filters([streamField.pinned(true), subscriptionField.pinned(true)]).actions(['create', 'filter']);
	
	  streamFeature.creationView().title('Create stream feature').fields([streamField, subscriptionField, nga.field('feature_type').defaultValue(1)]);
	  streamFeature.editionView().title('Edit stream feature').fields(streamFeature.creationView().fields()).actions(['list']);
	
	  return streamFeature;
	};
	
	var initPostingPolicy = function initPostingPolicy(nga) {
	  var entity = nga.entity('posting_policy').identifier(nga.field('stream_id')).label('Traffic light policies');
	  var streamField = nga.field('stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream')).targetField(nga.field('name')).remoteComplete(true, {
	    searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    }
	  });
	  entity.listView().title('Traffic light policies').fields([nga.field('stream_id'), streamField, nga.field('speed_threshold'), nga.field('wait_time')]).filters([streamField.pinned(true)]).actions(['create', 'filter']).sortField('stream_id');
	
	  entity.creationView().title('Create posting policy').fields([streamField, nga.field('speed_threshold'), nga.field('wait_time')]);
	  entity.editionView().title('Edit posting policy').fields(entity.creationView().fields()).actions(['list']);
	
	  return entity;
	};
	
	var initFilter = function initFilter(nga) {
	  var subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')).remoteComplete(true, {
	    searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    }
	  });
	  var entity = nga.entity('filter');
	  entity.listView().title('Filter list').fields([nga.field('id').isDetailLink(true), nga.field('filter_name', 'string'), nga.field('whitelist_streams', 'reference_many').targetEntity(nga.entity('stream')).targetField(nga.field('name')), nga.field('user_id'), subscriptionField]).filters([subscriptionField]).actions(['create', 'filter']);
	
	  entity.showView().title('Filter info').fields([nga.field('id').isDetailLink(true), nga.field('filter_name', 'string'), nga.field('whitelist_streams', 'reference_many').targetEntity(nga.entity('stream')).targetField(nga.field('name')), nga.field('user_id'), subscriptionField]);
	
	  return entity;
	};
	
	function getJWTToken() {
	  var cookieMatch = document.cookie.match(/EzyInsights=(.*?)(?:;|$)/);
	  if (cookieMatch) return cookieMatch[1];
	}
	
	var ezyToken = null;
	
	var AdminModule = _angular2.default.module('app', ['ng-admin', 'ngCookies']).config(['NgAdminConfigurationProvider', 'FieldViewConfigurationProvider', 'RestangularProvider', function (nga, fvp, rp) {
	  ezyToken = getJWTToken();
	  if (ezyToken) {
	    var jwt = (0, _jwtDecode2.default)(ezyToken);
	    if (jwt.exp < Date.parse(new Date()) / 1000) {
	      location.href = '/login.html';
	    }
	    rp.setDefaultHeaders({ 'X-EzyInsights': ezyToken });
	  } else location.href = '/login.html';
	
	  rp.addFullRequestInterceptor(function (response, deferred, responseHandler) {
	    var cookie = getJWTToken();
	    var jwt = (0, _jwtDecode2.default)(cookie);
	    if (jwt.exp < Date.parse(new Date()) / 1000) {
	      location.href = '/login.html';
	    }
	    ezyToken = cookie;
	  });
	
	  // Fields
	  nga.registerFieldType('unixtime', __webpack_require__(901));
	  nga.registerFieldType('datedict', __webpack_require__(905));
	  nga.registerFieldType('bool_timestamp', __webpack_require__(906));
	  nga.registerFieldType('countries', __webpack_require__(908));
	  nga.registerFieldType('country', __webpack_require__(915));
	  nga.registerFieldType('language', __webpack_require__(916));
	  nga.registerFieldType('category', __webpack_require__(917));
	  nga.registerFieldType('timezone', __webpack_require__(918));
	
	  fvp.registerFieldView('unixtime', __webpack_require__(919));
	  fvp.registerFieldView('datedict', __webpack_require__(920));
	  fvp.registerFieldView('bool_timestamp', __webpack_require__(921));
	
	  var admin = nga.application('BOA').baseApiUrl(("") + "/api/");
	
	  admin.addEntity((0, _content.initPublisher)(nga));
	  admin.addEntity((0, _content.initStream)(nga));
	  admin.addEntity(initPostingPolicy(nga));
	  admin.addEntity((0, _content.initStoryBlacklist)(nga));
	  admin.addEntity(initStreamFeatures(nga));
	
	  admin.addEntity((0, _common.initSubscription)(nga));
	  admin.addEntity((0, _common.initPerson)(nga));
	  admin.addEntity((0, _common.initProfile)(nga));
	  admin.addEntity((0, _security.initRoles)(nga));
	  admin.addEntity(initSubscriptionUser(nga));
	  admin.addEntity(initFilter(nga));
	  admin.addEntity((0, _notification.initReport)(nga));
	  admin.addEntity((0, _notification.initReportUser)(nga));
	  admin.addEntity((0, _notification.initReportEmail)(nga));
	  admin.menu(nga.menu().addChild(nga.menu().template('\n        <a href="http://boav2.ezyinsights.com" target="_blank">\n            <span class="glyphicon glyphicon-new-window"></span>\n            Content sources\n        </a>')).addChild(nga.menu().title('Content sources').addChild(nga.menu(nga.entity('posting_policy'))).addChild(nga.menu(nga.entity('stream_feature')))).addChild(nga.menu().title('Data').addChild(nga.menu(nga.entity('story_blacklist')))).addChild(nga.menu().title('Accounts').addChild(nga.menu(nga.entity('person')).title('User')).addChild(nga.menu(nga.entity('profile'))).addChild(nga.menu(nga.entity('subscription'))).addChild(nga.menu(nga.entity('user_subscription'))).addChild(nga.menu(nga.entity('roles'))).addChild(nga.menu(nga.entity('notification_report')).title('Email report')).addChild(nga.menu(nga.entity('notification_report_user')).title('Email report user')).addChild(nga.menu(nga.entity('notification_report_email')).title('Email report email'))).addChild(nga.menu(nga.entity('filter'))));
	
	  admin.dashboard(nga.dashboard().template(_dashboard2.default));
	  nga.configure(admin);
	}]);
	
	AdminModule.controller('SearchController', ['$scope', '$http', '$location', function ($scope, $http, $location) {
	  var searchTerm = $location.search()['search-term'];
	  $scope.search_term = searchTerm;
	  $scope.searchStatus = null;
	  $scope.allowSearch = true;
	
	  $scope.search = function () {
	    var url = 'https://boa.ezyinsights.com/api/search/' + $scope.search_term;
	    $scope.data = null;
	    $scope.results = null;
	    $scope.searchStatus = 'Searching please wait...';
	    $scope.allowSearch = false;
	    $http.get(url).then(function onSuccess(response) {
	      var data = response.data;
	      $scope.data = data;
	      $scope.logs = data.logs;
	      $scope.canonical = data.canonical;
	      $scope.publisher = data.publisher;
	      $scope.realtime = data.realtime;
	      $scope.sources = (0, _keys2.default)(data.sources).reduce(function (o, k) {
	        var v = data.sources[k];
	        v['message_id'] = k;
	        v['created_at'] = Math.min(v.html ? v.html.created_at : Math.MAX_SAFE_INTEGER, v.json ? v.json.created_at : Math.MAX_SAFE_INTEGER);
	        o.push(v);
	        return o;
	      }, []);
	      $scope.results = (0, _keys2.default)(data).filter(function (k) {
	        return !['logs'].includes(k);
	      }).reduce(function (o, k) {
	        o[k] = data[k];
	        return o;
	      }, {});
	      $scope.searchStatus = 'Search results for "' + $scope.search_term + '":';
	      $scope.allowSearch = true;
	    }, function onError(response) {
	      $scope.searchStatus = 'Search failed please try again!';
	      $scope.allowSearch = true;
	      console.error(response);
	    });
	  };
	
	  if (searchTerm) {
	    $scope.search();
	  }
	
	  $scope.copyToClipboard = function () {
	    var textArea = document.createElement("textarea");
	
	    textArea.style.position = 'fixed';
	    textArea.style.top = '0';
	    textArea.style.left = '0';
	    textArea.style.width = '2em';
	    textArea.style.height = '2em';
	    textArea.style.padding = '0';
	    textArea.style.border = 'none';
	    textArea.style.outline = 'none';
	    textArea.style.boxShadow = 'none';
	    textArea.style.background = 'transparent';
	
	    textArea.value = (0, _stringify2.default)($scope.data);
	
	    document.body.appendChild(textArea);
	    textArea.focus();
	    textArea.select();
	
	    try {
	      var successful = document.execCommand('copy');
	      var msg = successful ? 'successful' : 'unsuccessful';
	      console.log('Copying text command was ' + msg);
	    } catch (err) {
	      console.log('Oops, unable to copy');
	    }
	
	    document.body.removeChild(textArea);
	  };
	}]);
	
	AdminModule.filter('timeAgo', ['$interval', function ($interval) {
	  // trigger digest every 60 seconds
	  $interval(function () {}, 60000);
	
	  function fromNowFilter(time) {
	    return (0, _moment2.default)(time).fromNow();
	  }
	
	  fromNowFilter.$stateful = true;
	  return fromNowFilter;
	}]);
	
	AdminModule.filter('localTime', function () {
	  function fromNowFilter(isoTime) {
	    return _moment2.default.utc(isoTime).local().format('YYYY-MM-DD HH:mm:ss.SSS Z');
	  }
	  return fromNowFilter;
	});
	
	AdminModule.directive('ezyImpersonateButton', _ezyImpersonateButton2.default);
	AdminModule.directive('ezyManageSubscription', _ezyManageSubscription2.default);
	AdminModule.directive('ezyBoolTimestampField', _ezyBoolTimestampField2.default);
	AdminModule.directive('ezyDisableStoryButton', _ezyDisableStoryButton2.default);
	AdminModule.directive('ezyLogsTable', _ezyLogsTable2.default);

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(740);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(741);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default,
	  restrict: 'E'
	};
	
	exports.default = appComponent;

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div class=\"app\" ng-app=\"app\" ng-strict-di>\n  <div ui-view=\"ng-admin\"></div>\n</div>\n"

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(742);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(745)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/stylus-loader/index.js!./app.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(743)();
	// imports
	exports.i(__webpack_require__(744), "");
	
	// module
	exports.push([module.id, ".app{height:100%;background-color:$lightBgColor}.subscription-logo-url{max-height:50px;max-width:50px}.copyToClipboard{margin:10px}", ""]);
	
	// exports


/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.minutesToMs = exports.msToMinutes = exports.addViewErrorHandler = exports.getRoleEntity = exports.getDiscriminatorField = exports.mapInterval = exports.fromTimestamp = exports.toTimestamp = exports.formatDateDict = exports.DISCRIMINATOR_RSS = exports.DISCRIMINATOR_FACEBOOK = undefined;
	
	var _moment = __webpack_require__(750);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DISCRIMINATOR_FACEBOOK = exports.DISCRIMINATOR_FACEBOOK = 1;
	var DISCRIMINATOR_RSS = exports.DISCRIMINATOR_RSS = 1;
	
	var formatDateDict = exports.formatDateDict = function formatDateDict(prefix, alertTimeDelta) {
	  return function (value, entry) {
	    if (!entry[prefix + '.year']) return null;
	    var res = new String(entry[prefix + '.year'] + '-' + _.padStart(entry[prefix + '.month'], 2, 0) + '-' + _.padStart(entry[prefix + '.day'], 2, 0) + (' ' + _.padStart(entry[prefix + '.hour'], 2, 0) + ':' + _.padStart(entry[prefix + '.minute'], 2, 0) + ':' + _.padStart(entry[prefix + '.second'], 2, 0)));
	    if (alertTimeDelta && entry[alertTimeDelta + '.minutes']) {
	      res.outdated = true;
	    }
	    return res;
	  };
	};
	
	var toTimestamp = exports.toTimestamp = function toTimestamp(prefix) {
	  var dateFormatter = formatDateDict(prefix);
	  return function (value, entry) {
	    var dateString = dateFormatter(value, entry);
	    var res = parseInt((0, _moment2.default)(dateString, 'YYYY-MM-DD hh:mm:ss').format('X'), 10);
	    return res;
	  };
	};
	
	var fromTimestamp = exports.fromTimestamp = function fromTimestamp(value, entry) {
	  if (!value) {
	    return value;
	  }
	  var date = (0, _moment2.default)(value, 'X');
	  return {
	    year: date.year(),
	    month: date.month(),
	    day: date.date(),
	    hour: date.hour(),
	    minute: date.minute(),
	    second: date.second(),
	    __type__: 'datetime'
	  };
	};
	
	var mapInterval = exports.mapInterval = function mapInterval(prefix) {
	  return function (value, entry) {
	    return {
	      "hours": entry[prefix + '.hours'],
	      "minutes": entry[prefix + '.minutes'],
	      "seconds": entry[prefix + '.seconds']
	    };
	  };
	};
	
	var getDiscriminatorField = exports.getDiscriminatorField = function getDiscriminatorField(nga) {
	  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'discriminator';
	
	  return nga.field(name, 'choice').choices([{ value: 1, label: 'Facebook' }, { value: 2, label: 'Twitter' }, { value: 5, label: 'RSS' }, { value: 6, label: 'Instagram' }, { value: 7, label: 'Email' }]).validation({ required: true });
	};
	
	var getRoleEntity = exports.getRoleEntity = function getRoleEntity(nga) {
	  return nga.entity('roles').label('Roles').url(function (entityName, viewType, identifierValue, identifierName) {
	    return 'security/role' + (identifierValue ? '/' + identifierValue : '');
	  });
	};
	
	var addViewErrorHandler = exports.addViewErrorHandler = function addViewErrorHandler(view) {
	  return view.onSubmitError(['error', 'form', 'progression', 'notification', function (error, form, progression, notification) {
	    // mark fields based on errors from the response
	    console.log(error);
	    var errorMessage = void 0;
	    error.data.forEach(function (violation) {
	      if (form[violation.propertyPath]) {
	        form[violation.propertyPath].$valid = false;
	        errorMessage = violation.message;
	      }
	    });
	    // stop the progress bar
	    progression.done();
	    // add a notification
	    notification.log(errorMessage, { addnCls: 'humane-flatty-error' });
	    // cancel the default action (default error messages)
	    return false;
	  }]);
	};
	
	var msToMinutes = exports.msToMinutes = function msToMinutes(prefix) {
	  return function (value, entry) {
	    return value / 60000;
	  };
	};
	
	var minutesToMs = exports.minutesToMs = function minutesToMs(prefix) {
	  return function (value, entry) {
	    return value * 60000;
	  };
	};

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 752,
		"./af.js": 752,
		"./ar": 753,
		"./ar-dz": 754,
		"./ar-dz.js": 754,
		"./ar-kw": 755,
		"./ar-kw.js": 755,
		"./ar-ly": 756,
		"./ar-ly.js": 756,
		"./ar-ma": 757,
		"./ar-ma.js": 757,
		"./ar-sa": 758,
		"./ar-sa.js": 758,
		"./ar-tn": 759,
		"./ar-tn.js": 759,
		"./ar.js": 753,
		"./az": 760,
		"./az.js": 760,
		"./be": 761,
		"./be.js": 761,
		"./bg": 762,
		"./bg.js": 762,
		"./bm": 763,
		"./bm.js": 763,
		"./bn": 764,
		"./bn-bd": 765,
		"./bn-bd.js": 765,
		"./bn.js": 764,
		"./bo": 766,
		"./bo.js": 766,
		"./br": 767,
		"./br.js": 767,
		"./bs": 768,
		"./bs.js": 768,
		"./ca": 769,
		"./ca.js": 769,
		"./cs": 770,
		"./cs.js": 770,
		"./cv": 771,
		"./cv.js": 771,
		"./cy": 772,
		"./cy.js": 772,
		"./da": 773,
		"./da.js": 773,
		"./de": 774,
		"./de-at": 775,
		"./de-at.js": 775,
		"./de-ch": 776,
		"./de-ch.js": 776,
		"./de.js": 774,
		"./dv": 777,
		"./dv.js": 777,
		"./el": 778,
		"./el.js": 778,
		"./en-au": 779,
		"./en-au.js": 779,
		"./en-ca": 780,
		"./en-ca.js": 780,
		"./en-gb": 781,
		"./en-gb.js": 781,
		"./en-ie": 782,
		"./en-ie.js": 782,
		"./en-il": 783,
		"./en-il.js": 783,
		"./en-in": 784,
		"./en-in.js": 784,
		"./en-nz": 785,
		"./en-nz.js": 785,
		"./en-sg": 786,
		"./en-sg.js": 786,
		"./eo": 787,
		"./eo.js": 787,
		"./es": 788,
		"./es-do": 789,
		"./es-do.js": 789,
		"./es-mx": 790,
		"./es-mx.js": 790,
		"./es-us": 791,
		"./es-us.js": 791,
		"./es.js": 788,
		"./et": 792,
		"./et.js": 792,
		"./eu": 793,
		"./eu.js": 793,
		"./fa": 794,
		"./fa.js": 794,
		"./fi": 795,
		"./fi.js": 795,
		"./fil": 796,
		"./fil.js": 796,
		"./fo": 797,
		"./fo.js": 797,
		"./fr": 798,
		"./fr-ca": 799,
		"./fr-ca.js": 799,
		"./fr-ch": 800,
		"./fr-ch.js": 800,
		"./fr.js": 798,
		"./fy": 801,
		"./fy.js": 801,
		"./ga": 802,
		"./ga.js": 802,
		"./gd": 803,
		"./gd.js": 803,
		"./gl": 804,
		"./gl.js": 804,
		"./gom-deva": 805,
		"./gom-deva.js": 805,
		"./gom-latn": 806,
		"./gom-latn.js": 806,
		"./gu": 807,
		"./gu.js": 807,
		"./he": 808,
		"./he.js": 808,
		"./hi": 809,
		"./hi.js": 809,
		"./hr": 810,
		"./hr.js": 810,
		"./hu": 811,
		"./hu.js": 811,
		"./hy-am": 812,
		"./hy-am.js": 812,
		"./id": 813,
		"./id.js": 813,
		"./is": 814,
		"./is.js": 814,
		"./it": 815,
		"./it-ch": 816,
		"./it-ch.js": 816,
		"./it.js": 815,
		"./ja": 817,
		"./ja.js": 817,
		"./jv": 818,
		"./jv.js": 818,
		"./ka": 819,
		"./ka.js": 819,
		"./kk": 820,
		"./kk.js": 820,
		"./km": 821,
		"./km.js": 821,
		"./kn": 822,
		"./kn.js": 822,
		"./ko": 823,
		"./ko.js": 823,
		"./ku": 824,
		"./ku.js": 824,
		"./ky": 825,
		"./ky.js": 825,
		"./lb": 826,
		"./lb.js": 826,
		"./lo": 827,
		"./lo.js": 827,
		"./lt": 828,
		"./lt.js": 828,
		"./lv": 829,
		"./lv.js": 829,
		"./me": 830,
		"./me.js": 830,
		"./mi": 831,
		"./mi.js": 831,
		"./mk": 832,
		"./mk.js": 832,
		"./ml": 833,
		"./ml.js": 833,
		"./mn": 834,
		"./mn.js": 834,
		"./mr": 835,
		"./mr.js": 835,
		"./ms": 836,
		"./ms-my": 837,
		"./ms-my.js": 837,
		"./ms.js": 836,
		"./mt": 838,
		"./mt.js": 838,
		"./my": 839,
		"./my.js": 839,
		"./nb": 840,
		"./nb.js": 840,
		"./ne": 841,
		"./ne.js": 841,
		"./nl": 842,
		"./nl-be": 843,
		"./nl-be.js": 843,
		"./nl.js": 842,
		"./nn": 844,
		"./nn.js": 844,
		"./oc-lnc": 845,
		"./oc-lnc.js": 845,
		"./pa-in": 846,
		"./pa-in.js": 846,
		"./pl": 847,
		"./pl.js": 847,
		"./pt": 848,
		"./pt-br": 849,
		"./pt-br.js": 849,
		"./pt.js": 848,
		"./ro": 850,
		"./ro.js": 850,
		"./ru": 851,
		"./ru.js": 851,
		"./sd": 852,
		"./sd.js": 852,
		"./se": 853,
		"./se.js": 853,
		"./si": 854,
		"./si.js": 854,
		"./sk": 855,
		"./sk.js": 855,
		"./sl": 856,
		"./sl.js": 856,
		"./sq": 857,
		"./sq.js": 857,
		"./sr": 858,
		"./sr-cyrl": 859,
		"./sr-cyrl.js": 859,
		"./sr.js": 858,
		"./ss": 860,
		"./ss.js": 860,
		"./sv": 861,
		"./sv.js": 861,
		"./sw": 862,
		"./sw.js": 862,
		"./ta": 863,
		"./ta.js": 863,
		"./te": 864,
		"./te.js": 864,
		"./tet": 865,
		"./tet.js": 865,
		"./tg": 866,
		"./tg.js": 866,
		"./th": 867,
		"./th.js": 867,
		"./tk": 868,
		"./tk.js": 868,
		"./tl-ph": 869,
		"./tl-ph.js": 869,
		"./tlh": 870,
		"./tlh.js": 870,
		"./tr": 871,
		"./tr.js": 871,
		"./tzl": 872,
		"./tzl.js": 872,
		"./tzm": 873,
		"./tzm-latn": 874,
		"./tzm-latn.js": 874,
		"./tzm.js": 873,
		"./ug-cn": 875,
		"./ug-cn.js": 875,
		"./uk": 876,
		"./uk.js": 876,
		"./ur": 877,
		"./ur.js": 877,
		"./uz": 878,
		"./uz-latn": 879,
		"./uz-latn.js": 879,
		"./uz.js": 878,
		"./vi": 880,
		"./vi.js": 880,
		"./x-pseudo": 881,
		"./x-pseudo.js": 881,
		"./yo": 882,
		"./yo.js": 882,
		"./zh-cn": 883,
		"./zh-cn.js": 883,
		"./zh-hk": 884,
		"./zh-hk.js": 884,
		"./zh-mo": 885,
		"./zh-mo.js": 885,
		"./zh-tw": 886,
		"./zh-tw.js": 886
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 751;


/***/ }),

/***/ 889:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initProfile = exports.initSubscription = exports.initPerson = undefined;
	
	var _helpers = __webpack_require__(749);
	
	var initSubscription = function initSubscription(nga) {
	  var subscription = nga.entity('subscription');
	  var defaultFilterField = nga.field('default_filter_id', 'reference').label('Default filter').targetEntity(nga.entity('filter')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    } }).validation({ required: true });
	
	  var facebookPageField = nga.field('facebook_pages', 'reference_many').targetEntity(nga.entity('stream')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	      return { name__icontains: search, discriminator: _helpers.DISCRIMINATOR_FACEBOOK };
	    } }).validation({ required: true });
	
	  subscription.listView().title('Subscription list').fields([nga.field('id').isDetailLink(true), nga.field('name', 'string'), nga.field('logo_url').template('<img class="subscription-logo-url" ng-if="value" alt="logo" src="{{value}}" />'), nga.field('country', 'country'), nga.field('invite_code').template('<span>https://app.ezyinsights.com/login/invite/{{value}}</span>'), nga.field('disabled_at', 'bool_timestamp').label('Disabled')]).filters([nga.field('name__icontains').label('Name')]).actions(['create', 'filter']).listActions(['edit', '<ezy-manage-subscription size="xs" entity="::entity" entry="::entry" />']);
	
	  subscription.creationView().title('Create subscription').fields([nga.field('name', 'string'), nga.field('logo_url'), nga.field('invite_code'), nga.field('country', 'country'), defaultFilterField, facebookPageField, nga.field('users', 'referenced_list').targetEntity(nga.entity('user_subscription')).targetReferenceField('subscription_id').targetFields([nga.field('user_id'), nga.field('email')]).listActions(['edit']), nga.field('disabled_at', 'bool_timestamp').label('Disabled'), nga.field('timezone', 'timezone'), nga.field('filters', 'referenced_list').targetEntity(nga.entity('filter')).targetReferenceField('subscription_id').targetFields([nga.field('id'), nga.field('filter_name')]).listActions([]).remoteComplete(true, { searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    } }), nga.field('roles', 'referenced_list').targetEntity((0, _helpers.getRoleEntity)(nga)).targetReferenceField('subscription_id').targetFields([nga.field('id'), nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('email')), nga.field('role_type_str')]).listActions(['edit'])]);
	  subscription.editionView().title('Edit subscription').fields(subscription.creationView().fields()).actions(['list']);;
	
	  return subscription;
	};
	
	var initPerson = function initPerson(nga) {
	  var createAction = '<ma-create-button ng-if="::entity.creationView().enabled" entry="::entry" entity="::entity" default-values="{user_id:entry.values.user_id}" size="xs"></ma-create-button>';
	  var subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    } });
	  var person = nga.entity('person').label('User');
	  person.listView().title('User list').fields([nga.field('user_id').isDetailLink(true), nga.field('full_name', 'string'), nga.field('email', 'email'), subscriptionField]).filters([nga.field('email__icontains').label('Email'), nga.field('full_name__icontains').label('Full Name')]).actions(['filter']).sortField("id").listActions(['edit', '<ezy-impersonate-button size="xs" entity="::entity" entry="::entry" />']);
	
	  person.creationView().title('Create user').fields([nga.field('full_name', 'string'), nga.field('email', 'email'), nga.field('profiles', 'referenced_list').targetEntity(nga.entity('profile')).targetReferenceField('user_id').targetFields([nga.field('id'), (0, _helpers.getDiscriminatorField)(nga, 'social_type'), nga.field('eid')]), nga.field('roles', 'referenced_list').targetEntity((0, _helpers.getRoleEntity)(nga)).targetReferenceField('user_id').targetFields([nga.field('id'), nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')), nga.field('role_type_str').label('Role Type')]).listActions(['edit', createAction, 'delete']), subscriptionField]);
	  person.editionView().title('Edit user').fields(person.creationView().fields());
	
	  return person;
	};
	
	var initProfile = function initProfile(nga) {
	  var userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('full_name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    } });
	  var profile = nga.entity('profile');
	  profile.listView().title('Profile list').fields([nga.field('id').isDetailLink(true), nga.field('eid', 'string'), (0, _helpers.getDiscriminatorField)(nga, 'social_type'), userField]).filters([nga.field('email__icontains').label('Email'), nga.field('eid__icontains').label('EID'), nga.field('first_name__icontains').label('First Name'), nga.field('last_name__icontains').label('Last Name')]).actions(['filter']).sortField("id").listActions(['edit', '<ezy-impersonate-button size="xs" entity="::entity" entry="::entry" />']);
	
	  profile.creationView().title('Create Profile').fields([nga.field('first_name', 'string'), nga.field('last_name', 'string'), nga.field('registered_at', 'string').editable(false), nga.field('eid', 'string'), nga.field('email', 'email'), (0, _helpers.getDiscriminatorField)(nga, 'social_type'), userField]);
	  profile.editionView().title('Edit Profile').fields(profile.creationView().fields());
	
	  return profile;
	};
	
	exports.initPerson = initPerson;
	exports.initSubscription = initSubscription;
	exports.initProfile = initProfile;

/***/ }),

/***/ 890:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initStoryBlacklist = exports.initPublisher = exports.initStream = undefined;
	
	var _helpers = __webpack_require__(749);
	
	var _lodash = __webpack_require__(602);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initPublisher = function initPublisher(nga) {
	  var createAction = '<ma-create-button ng-if="::entity.creationView().enabled" entry="::entry" entity="::entity" default-values="{publisher_id:entry.values.publisher_id}" size="xs"></ma-create-button>';
	  var publishers = nga.entity('publisher');
	  publishers.label('Publishers');
	  var parentField = nga.field('parent_id', 'reference').targetEntity(nga.entity('publisher')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    } });
	
	  publishers.showView().title('Publisher').fields([nga.field('name'), nga.field('timezone', 'timezone'), nga.field('attribution_rank', 'number').attributes({ placeholder: 'Used in someindex' }), nga.field('domain_list').transform(function (value) {
	    return value ? _lodash2.default.isString(value) ? value.split(/, ?/) : value : null;
	  }), nga.field('logo_url'), nga.field('attribution_country_ids', 'countries'), parentField, nga.field('disabled_at', 'bool_timestamp').label('Disabled').map(function (value) {
	    return value ? value / 1000 : null;
	  }).transform(function (value) {
	    return value ? value * 1000 : null;
	  }), nga.field('streams', 'referenced_list').targetEntity(nga.entity('stream')).targetReferenceField('publisher_id').targetFields([nga.field('id'), nga.field('_name'), (0, _helpers.getDiscriminatorField)(nga)]).listActions(['edit', createAction]), nga.field('children', 'referenced_list').targetEntity(nga.entity('publisher')).targetReferenceField('parent_id').targetFields([nga.field('id'), nga.field('name')])]);
	  return publishers;
	};
	
	var initStream = function initStream(nga) {
	  var stream = nga.entity('stream');
	
	  var discriminatorField = (0, _helpers.getDiscriminatorField)(nga);
	  var readonlyDiscriminatorField = (0, _helpers.getDiscriminatorField)(nga);
	  var categoryTypesField = nga.field('category_types', 'reference_many').targetEntity(nga.entity('references_stream_category').identifier(nga.field('code'))).targetField(nga.field('name')).validation({ required: true });
	  var languageField = nga.field('language_ids', 'reference_many').targetEntity(nga.entity('references_language').identifier(nga.field('code'))).targetField(nga.field('name')).validation({ required: true });
	  var publisherField = nga.field('publisher_id', 'reference').label('Publisher').targetEntity(nga.entity('publisher')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	      return { name__icontains: search };
	    } });
	  var disabledField = nga.field('disabled_at', 'bool_timestamp').label('Disabled').map(function (value) {
	    return value ? value / 1000 : null;
	  }).transform(function (value) {
	    return value ? value * 1000 : null;
	  });
	  var nameField = nga.field('_name').label('New Name').validation({ required: true });
	  var eidField = nga.field('eid').cssClasses(function (entity) {
	    return entity.values.discriminator != 1 && entity.values.discriminator != 2 && entity.values.discriminator != 6 ? 'hidden' : '';
	  });
	  var urlField = nga.field('url').cssClasses(function (entity) {
	    return entity.values.discriminator != 5 ? 'hidden' : '';
	  });
	  var tokenPolicyField = nga.field('acquisition.token_policy_id', 'reference').label('Token Policy').targetEntity(nga.entity('policy_token')).targetField(nga.field('name')).permanentFilters({ name__ne: "Canonical URLs" }).defaultValue(1);
	  var subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name'));
	  stream.label('Streams');
	  stream.showView().title('Stream').fields([nga.field('id').isDetailLink(true), nga.field('_name', 'string').label('Name'), publisherField, nga.field('logo_url'), nga.field('disabled_at', 'unixtime').label('Manually disabled').map(function (value) {
	    return value ? value / 1000 : null;
	  }), discriminatorField]);
	  return stream;
	};
	
	var initStoryBlacklist = function initStoryBlacklist(nga) {
	  var entity = nga.entity('story_blacklist').label('Story blacklist').identifier(nga.field('story_id'));
	  entity.listView().title('Story list').fields([nga.field('story_id').isDetailLink(true)]).actions(['filter']).sortField('');
	
	  return entity;
	};
	
	exports.initStream = initStream;
	exports.initPublisher = initPublisher;
	exports.initStoryBlacklist = initStoryBlacklist;

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var initReport = function initReport(nga) {
	    var entity = nga.entity('notification_report').label('Email report');
	    var subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { name__icontains: search };
	        } });
	    var firstStreamField = nga.field('first_stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { name__icontains: search, discriminator: 1 };
	        } });
	    var secondStreamField = nga.field('second_stream_id', 'reference').label('Stream').targetEntity(nga.entity('stream')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { name__icontains: search, discriminator: 1 };
	        } });
	    var periodField = nga.field('period', 'choice').choices([{ value: 'daily', label: 'Daily' }, { value: 'weekly', label: 'Weekly' }, { value: 'weekdays', label: 'Weekdays' }]).validation({ required: true });
	    var dayOfWeekField = nga.field('day_of_week', 'number');
	    var userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('full_name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { full_name__icontains: search };
	        } });
	    var usersField = nga.field('users', 'referenced_list').targetEntity(nga.entity('notification_report_user')).targetReferenceField('report_id').targetFields([nga.field('id'), userField]).listActions(['edit']);
	    var emailsField = nga.field('emails', 'referenced_list').targetEntity(nga.entity('notification_report_email')).targetReferenceField('report_id').targetFields([nga.field('id'), nga.field('email')]).listActions(['edit']);
	    entity.listView().title('Email report list').fields([nga.field('id').isDetailLink(true), firstStreamField, secondStreamField, subscriptionField, periodField, nga.field('last_sent_at', 'unixtime'), nga.field('disabled_at', 'unixtime')]);
	    entity.creationView().fields([firstStreamField, secondStreamField, subscriptionField, periodField, dayOfWeekField, usersField, emailsField]);
	    entity.editionView().fields([firstStreamField, secondStreamField, subscriptionField, periodField, dayOfWeekField, usersField, emailsField, nga.field('disabled_at', 'bool_timestamp')]);
	    return entity;
	};
	
	var initReportUser = function initReportUser(nga) {
	    var entity = nga.entity('notification_report_user').label('Email report user');
	    var reportField = nga.field('report_id', 'reference').label('Report').targetEntity(nga.entity('notification_report')).targetField(nga.field('id')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { id: search };
	        } });
	    var userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('full_name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { full_name__icontains: search };
	        } });
	    entity.listView().title('Email report list').fields([nga.field('id').isDetailLink(true), userField, reportField]).filters([reportField, userField]);
	    entity.creationView().fields([userField, reportField]);
	    entity.editionView().fields([userField, reportField]);
	
	    return entity;
	};
	
	var initReportEmail = function initReportEmail(nga) {
	    var entity = nga.entity('notification_report_email').label('Email report user');
	    var reportField = nga.field('report_id', 'reference').label('Report').targetEntity(nga.entity('notification_report')).targetField(nga.field('id')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { id: search };
	        } });
	    var emailField = nga.field('email', 'string').label('Email');
	    entity.listView().title('Email report list').fields([nga.field('id').isDetailLink(true), emailField, reportField]).filters([reportField, emailField]);
	    entity.creationView().fields([emailField, reportField]);
	    entity.editionView().fields([emailField, reportField]);
	
	    return entity;
	};
	
	exports.initReport = initReport;
	exports.initReportUser = initReportUser;
	exports.initReportEmail = initReportEmail;

/***/ }),

/***/ 892:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initRoles = undefined;
	
	var _helpers = __webpack_require__(749);
	
	var initRoles = function initRoles(nga) {
	    var entity = (0, _helpers.getRoleEntity)(nga);
	    var userField = nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('full_name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { full_name__icontains: search };
	        } });
	    var subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')).remoteComplete(true, { searchQuery: function searchQuery(search) {
	            return { name__icontains: search };
	        } });
	    var roleTypesField = nga.field('role_type', 'reference').targetEntity(nga.entity('references_role').identifier(nga.field('code'))).targetField(nga.field('name')).validation({ required: true });
	    entity.listView().title('Role list').fields([nga.field('id').isDetailLink(true), nga.field('user_id', 'reference').label('User').targetEntity(nga.entity('person')).targetField(nga.field('email')), nga.field('disabled_at', 'unixtime').map(function (value) {
	        return value && value / 1000;
	    }), nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription')).targetField(nga.field('name')), nga.field('role_type_str').label('Role Type'), nga.field('service_type_str').label('Service type')]).filters([userField.pinned(true), subscriptionField.pinned(true)]).actions(['create', 'filter', 'delete']);
	    entity.creationView().title('Create role').fields([userField, subscriptionField, roleTypesField, nga.field('service_type', 'choice').label('Service type').choices([{ label: 'Realtime', value: 1 }, { label: 'SoMeIndex', value: 2 }])]);
	    entity.showView().title('View role').fields([userField, subscriptionField, nga.field('role_type_str').label('Role Type'), nga.field('service_type_str').label('Service type')]);
	    entity.deletionView();
	
	    return entity;
	};
	
	exports.initRoles = initRoles;

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(894);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = ezyImpersonateDirective;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Link to delete
	 *
	 * Usage:
	 * <ma-delete-button entity="entity" entry="entry" size="xs"></ma-delete-button>
	 */
	function ezyImpersonateDirective($state, $http, $cookies, ReadQueries) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'Impersonate';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? (0, _extends3.default)({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	            scope.impersonate = function () {
	                ReadQueries.getOne(scope.entity(), 'ShowView', stateParams.id, 'ShowView', null).then(function (entry) {
	                    console.log(entry);
	                    $http({
	                        method: 'POST',
	                        url: 'https://app.ezyinsights.com/api/user/' + entry.user_id + '/impersonate',
	                        headers: {
	                            'X-EzyInsights': $cookies.get('X-EzyInsights')
	                        }
	                    }).success(function (json, status, getHeaders, response) {
	                        $cookies.put('X-EzyInsights', json.token, {
	                            domain: '.ezyinsights.com'
	                        });
	                        alert('Impersonated in the new tool');
	                    });
	                }).catch(function (err) {
	                    return console.error(err);
	                });
	            };
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="impersonate(stateParams)">\n<span class="glyphicon glyphicon-user" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	ezyImpersonateDirective.$inject = ['$state', '$http', '$cookies', 'ReadQueries'];

/***/ }),

/***/ 895:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(894);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = ezyManageSubscriptionDirective;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ezyManageSubscriptionDirective($state, $http, ReadQueries) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'Manage Subscripion';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? (0, _extends3.default)({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	            scope.manage = function () {
	                ReadQueries.getOne(scope.entity(), 'ShowView', stateParams.id, 'ShowView', null).then(function (entry) {
	                    $http({
	                        method: 'POST',
	                        url: 'https://app.ezyinsights.com/api/subscription/' + entry.id + '/manage/',
	                        withCredentials: true
	                    }).success(function () {
	                        window.open('https://app.ezyinsights.com', '_blank');
	                    });
	                }).catch(function (err) {
	                    return console.error(err);
	                });
	            };
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="manage(stateParams)">\n<span class="glyphicon glyphicon-cog" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	ezyManageSubscriptionDirective.$inject = ['$state', '$http', 'ReadQueries'];

/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ezyBoolTimestampField;
	
	var _moment = __webpack_require__(750);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateChoices(scope, choices) {
	    scope.choices = choices;
	    scope.$root.$$phase || scope.$digest();
	}
	
	function ezyBoolTimestampField($compile) {
	    return {
	        scope: {
	            'field': '&',
	            'value': '=',
	            'entry': '=?',
	            'datastore': '&?',
	            'refresh': '&',
	            'choices': '&?'
	        },
	        restrict: 'E',
	        compile: function compile() {
	            return {
	                pre: function pre(scope, element) {
	                    var field = scope.field();
	                    var attributes = field.attributes();
	                    scope.placeholder = attributes && attributes.placeholder || 'FILTER_VALUES';
	                    scope.name = field.name();
	                    scope.v = field.validation();
	                    scope.$watch('value', function (newValue, oldValue) {
	                        if (newValue !== oldValue && newValue === undefined) {
	                            // fix for https://github.com/angular-ui/ui-select/issues/863
	                            scope.value = null;
	                        }
	                    });
	
	                    var refreshAttributes = '';
	                    var itemsFilter = '| filter: {label: $select.search}';
	                    if (field.type().indexOf('reference') === 0 && field.remoteComplete()) {
	                        // FIXME wrong place to do that
	                        scope.refreshDelay = field.remoteCompleteOptions().refreshDelay;
	                        refreshAttributes = 'refresh-delay="refreshDelay" refresh="refresh({ $search: $select.search })"';
	                        itemsFilter = '';
	                    }
	
	                    var choices = typeof scope.choices == 'function' && scope.choices() ? scope.choices() : field.choices ? field.choices() : [];
	                    scope.currentDate = scope.$parent.value ? (0, _moment2.default)(scope.$parent.value, 'X').format() : null;
	                    if (scope.$parent.value) {
	                        console.log(scope.$parent.value);
	                        choices.push({
	                            label: 'Yes (do not bump field date)',
	                            value: scope.$parent.value || ""
	                        });
	                    }
	
	                    var template = '\n                        <ui-select ng-model="$parent.value" ng-required="v.required" id="{{ name }}" name="{{ name }}">\n                            <ui-select-match allow-clear="{{ false }}" placeholder="{{ placeholder | translate }}">{{ $select.selected.label | translate }}</ui-select-match>\n                            <ui-select-choices ' + refreshAttributes + ' repeat="item.value as item in choices ' + itemsFilter + '  track by $index">\n                                {{ item.label | translate }}\n                            </ui-select-choices>\n                        </ui-select>';
	
	                    scope.choices = typeof choices === 'function' ? choices(scope.entry) : choices;
	                    element.html(template);
	
	                    var select = element.children()[0];
	                    for (var name in attributes) {
	                        select.setAttribute(name, attributes[name]);
	                    }
	
	                    $compile(element.contents())(scope);
	                },
	                post: function post(scope) {
	                    scope.$on('choices:update', function (e, data) {
	                        updateChoices(scope, data.choices);
	                    });
	                }
	            };
	        }
	    };
	}
	
	ezyBoolTimestampField.$inject = ['$compile'];

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(894);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.default = ezyDisableStoryDirective;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Link to delete
	 *
	 * Usage:
	 * <ma-delete-button entity="entity" entry="entry" size="xs"></ma-delete-button>
	 */
	function ezyDisableStoryDirective($state, $http, ReadQueries) {
	    return {
	        restrict: 'E',
	        scope: {
	            entity: '&',
	            entityName: '@',
	            entry: '&',
	            size: '@',
	            label: '@'
	        },
	        link: function link(scope, element, attrs) {
	            scope.label = scope.label || 'Disable';
	            var entityName = scope.entity() ? scope.entity().name() : attrs.entityName;
	            var stateParams = entityName == $state.params.entity ? (0, _extends3.default)({}, $state.params) : {};
	            stateParams.entity = entityName;
	            stateParams.id = scope.entry().identifierValue;
	            scope.stateParams = stateParams;
	            scope.impersonate = function () {
	                ReadQueries.getOne(scope.entity(), 'ShowView', stateParams.id, 'ShowView', null).then(function (entry) {
	                    console.log(entry);
	                    $http({
	                        method: 'POST',
	                        url: 'https://app.ezyinsights.com/api/story/' + entry.id + '/hide',
	                        headers: {
	                            'X-EzyInsights': ('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjIjoxLCJpIjoxLCJyIjpbNF0sInUiOnsiaSI6IjU1NDEiLCJ0IjoyLCJuIjoiQk9BIn0sImV4cCI6MTUxMDMyMTUwNCwiaWF0IjoxNDc4Nzg1NTA0fQ.yx0PG7c-aT6zr24H104PU_5Yu1EMGwOHoguLxcuUgeY')
	                        },
	                        withCredentials: true
	                    }).success(function () {
	                        alert('Story was hidden');
	                    });
	                }).catch(function (err) {
	                    return console.error(err);
	                });
	            };
	        },
	        template: ' <a class="btn btn-default" ng-class="size ? \'btn-\' + size : \'\'" ng-click="impersonate(stateParams)">\n<span class="glyphicon glyphicon-user" aria-hidden="true"></span>&nbsp;<span class="hidden-xs" translate="{{ ::label }}"></span>\n</a>'
	    };
	}
	
	ezyDisableStoryDirective.$inject = ['$state', '$http', 'ReadQueries'];

/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ezyLogsTableDirective;
	
	var _ezyLogsTable = __webpack_require__(899);
	
	var _ezyLogsTable2 = _interopRequireDefault(_ezyLogsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ezyLogsTableDirective($scope) {
	  /* @ngInject */
	  Controller.$inject = ['$scope'];
	  function Controller($scope) {
	    $scope.toggleLog = function (index) {
	      $scope.showLogJson[index] = !$scope.showLogJson[index];
	    };
	
	    $scope.showJson = function (json, path) {
	      if ($scope[path]) {
	        $scope[path] = null;
	      } else {
	        $scope[path] = json;
	      }
	    };
	
	    $scope.resetJson = function (value) {
	      $scope.showLogJson = Array($scope.logs ? $scope.logs.length : 0).fill(value);
	    };
	    $scope.resetJson(false);
	  }
	  return {
	    restrict: 'AE',
	    scope: {
	      logs: '=',
	      label: '='
	    },
	    controller: Controller,
	    template: _ezyLogsTable2.default
	  };
	}
	
	ezyLogsTableDirective.$inject = [];

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

	module.exports = "<div class=\"row dashboard-content\" ng-if=\"logs\">\n  <div class=\"col-md-12\">\n    <div class=\"row\">\n      <div class=\"col-md-3\">\n        <h3>{{label}}</h3>\n      </div>\n      <div class=\"col-md-9\">\n        <div class=\"text-right\">\n          <button class=\"btn btn-default\" ng-click=\"resetJson(false)\">Collapse</button>\n          <button class=\"btn btn-default\" ng-click=\"resetJson(true)\">Expand</button>\n        </div>\n      </div>\n    </div>\n    <table ng-if=\"logs\" class=\"table table-striped table-bordered\">\n      <thead>\n      <tr>\n        <th>timestamp</th>\n        <th>levelname</th>\n        <th>message</th>\n        <th>replicaset.name</th>\n      </tr>\n      </thead>\n      <tbody>\n      <tr ng-repeat-start=\"log in logs\">\n        <td><a ng-click=\"toggleLog($index)\">{{log['@timestamp'] | localTime}}</a></td>\n        <td>{{log.levelname}}</td>\n        <td>{{log.message}}</td>\n        <td>{{log.kubernetes.replicaset.name}}</td>\n      </tr>\n      <tr ng-repeat-end ng-if=\"showLogJson[$index]\">\n        <td colspan=\"4\">\n          <pre>{{log | json}}</pre>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    <div class=\"page-header\">\n      <h1>Search</h1>\n    </div>\n  </div>\n</div>\n\n<div ng-controller=\"SearchController\">\n  <div class=\"row dashboard-content\">\n    <div class=\"col-md-11\">\n      <form novalidate class=\"simple-form\">\n        <div class=\"col-md-9\">\n          <input type=\"text\" class=\"form-control\" placeholder=\"type a url or story id here and press search\"\n                 ng-model=\"search_term\">\n        </div>\n        <div class=\"col-md-1\">\n          <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"search(search_term)\"\n                  ng-disabled=\"!allowSearch || !search_term\">Search\n          </button>\n        </div>\n      </form>\n    </div>\n  </div>\n  <div class=\"row dashboard-content\">\n    <div class=\"col-md-12\">\n      <h4>{{ searchStatus }}</h4>\n    </div>\n    <button class=\"btn btn-default\"\n            ng-if=\"data\"\n            ng-click=\"copyToClipboard()\">\n      copy to clipboard\n    </button>\n  </div>\n  <div class=\"row dashboard-content\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <h2 ng-if=\"canonical\">Canonical</h2>\n        <!--    Content Story    -->\n        <div ng-repeat=\"(key, entity) in canonical\" class=\"row\">\n          <div class=\"col-sm-12\">\n            <div class=\"row\">\n              <div class=\"col-sm-3 text-right\"><h4>{{key}}</h4></div>\n              <div class=\"col-sm-9\">\n                <a class=\"btn btn-default\" ng-click=\"showJson(entity, 'canonicalJson')\">Toggle JSON</a>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-sm-3 text-bold text-right\"><strong>id</strong></div>\n              <div class=\"col-sm-9 text-left\">{{ entity.id }}</div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-sm-3 text-right\"><strong>canonical_url</strong></div>\n              <div class=\"col-sm-9 text-left\">\n                <a target=\"_blank\" href=\"{{ entity.canonical_url }}\">{{ entity.canonical_url }}</a>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"col-sm-3 text-bold text-right\"><strong>discovered at</strong></div>\n              <div class=\"col-sm-9 text-left\">\n                {{ entity.discovered_at | date:'yyyy-MM-dd HH:mm:ss Z' }} ({{ entity.discovered_at | timeAgo }})\n              </div>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"canonicalJson\"\n             id=\"content-story-json\"\n             class=\"row\">\n          <div class=\"col-sm-12\">\n            <pre>{{ canonicalJson | json }}</pre>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row dashboard-content\" ng-if=\"publisher\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <h2>Publisher</h2>\n        <div class=\"row\">\n          <div class=\"col-sm-9 col-sm-offset-3\">\n            <a class=\"btn btn-default\" ng-click=\"showJson(publisher, 'publisherJson')\">Toggle JSON</a>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-3 text-bold text-right\"><strong>id</strong></div>\n          <div class=\"col-sm-9 text-left\">\n            <a target=\"_blank\"\n               href=\"#/publisher/edit/{{ publisher.id }}\">{{ publisher.id }}</a>\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-3 text-bold text-right\"><strong>name</strong></div>\n          <div class=\"col-sm-9 text-left\">{{ publisher.name }}</div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-3 text-bold text-right\"><strong>created at</strong></div>\n          <div class=\"col-sm-9 text-left\">\n            {{ publisher.created_at | date:'yyyy-MM-dd HH:mm:ss Z' }} ({{ publisher.created_at | timeAgo }})\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-3 text-bold text-right\"><strong>updated at</strong></div>\n          <div class=\"col-sm-9 text-left\">\n            {{ publisher.modified_at | date:'yyyy-MM-dd HH:mm:ss Z' }} ({{ publisher.modified_at | timeAgo }})\n          </div>\n        </div>\n        <div class=\"row\">\n          <div class=\"col-sm-3 text-bold text-right\"><strong>domain patterns</strong></div>\n          <div class=\"col-sm-9 text-left\">\n            <ul ng-if=\"publisher.domain_list\">\n              <li ng-repeat=\"domain in publisher.domain_list\">{{domain}}</li>\n            </ul>\n          </div>\n        </div>\n        <div ng-if=\"publisherJson\"\n             id=\"publisher-json\"\n             class=\"row\">\n          <div class=\"col-sm-12\">\n            <pre>{{ publisherJson | json }}</pre>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"row dashboard-content\" ng-if=\"sources\">\n    <div class=\"col-md-12\">\n      <div class=\"row\">\n        <div class=\"col-md-12\">\n          <h2>Sources</h2>\n        </div>\n      </div>\n      <table ng-if=\"sources\" class=\"table table-striped table-bordered\">\n        <thead>\n        <tr>\n          <th>message id</th>\n          <th>raw</th>\n          <th>parsed</th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"entity in sources | orderBy: 'created_at'\">\n          <td>{{ entity.message_id }}</td>\n          <td><a href=\"{{ entity.html.compare }}\" rel=\"noopener noreferrer\" target=\"_blank\">{{ entity.html.created_at | date:'yyyy-MM-dd HH:mm:ss Z' }}</a></td>\n          <td><a href=\"{{ entity.json.compare }}\" rel=\"noopener noreferrer\" target=\"_blank\">{{ entity.json.created_at | date:'yyyy-MM-dd HH:mm:ss Z' }}</a></td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"row dashboard-content\">\n    <div class=\"col-md-12\">\n      <h2 ng-if=\"realtime\">Realtime</h2>\n      <div ng-repeat=\"(key, entity) in realtime\" class=\"row\">\n        <div class=\"col-sm-12\">\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><h4>{{key}}</h4></div>\n            <div class=\"col-sm-9\">\n              <a class=\"btn btn-default\" ng-click=\"showJson(entity, 'realtimeJson')\">Toggle JSON</a>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-bold text-right\"><strong>id</strong></div>\n            <div class=\"col-sm-9 text-left\">\n              <a target=\"_blank\" href=\"https://app.ezyinsights.com/realtime/filter/1/story/{{ entity.id }}\">{{ entity.id\n                }}</a>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-right\"><strong>Publisher id</strong></div>\n            <div class=\"col-sm-9 text-left\">\n              <a target=\"_blank\"\n                 href=\"#/publisher/edit/{{ entity.publisher_id }}\"\n                 ng-if=\"entity.publisher_id\">{{ entity.publisher_id }}</a>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-bold text-right\"><strong>Story shown</strong></div>\n            <div class=\"col-sm-9 text-left\">\n              {{ entity.visibility.story }}\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-bold text-right\"><strong>Web shares shown</strong></div>\n            <div class=\"col-sm-9 text-left\">\n              {{ entity.visibility.extended }}\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-bold text-right\"><strong>Published At</strong></div>\n            <div class=\"col-sm-9 text-left\">\n              {{ entity.published_at | date:'yyyy-MM-dd HH:mm:ss Z' }} ({{ entity.published_at | timeAgo }})\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-bold text-right\"><strong>Last endorsed at</strong></div>\n            <div class=\"col-sm-9 text-left\">\n              {{ entity.last_endorsed_at | date:'yyyy-MM-dd HH:mm:ss Z' }} ({{ entity.last_endorsed_at | timeAgo }})\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 text-bold text-right\"><strong>Last sampled at</strong></div>\n            <div class=\"col-sm-9 text-left\">\n              {{ entity.last_sample_at | date:'yyyy-MM-dd HH:mm:ss Z' }} ({{ entity.last_sample_at | timeAgo }})\n            </div>\n          </div>\n        </div>\n      </div>\n      <div ng-if=\"realtimeJson\"\n           id=\"realtime-json\"\n           class=\"row\">\n        <div class=\"col-sm-12\">\n          <pre>{{ realtimeJson | json }}</pre>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"logs\">\n    <h1>Logs</h1>\n    <ezy-logs-table logs=\"logs.blurr_acquisition\" label=\"'blurr_acquisition'\"></ezy-logs-table>\n    <ezy-logs-table logs=\"logs.content_story\" label=\"'content_story'\"></ezy-logs-table>\n  </div>\n</div>\n"

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _DateTimeField2 = __webpack_require__(565);
	
	var _DateTimeField3 = _interopRequireDefault(_DateTimeField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimestampField = function (_DateTimeField) {
	    (0, _inherits3.default)(TimestampField, _DateTimeField);
	
	    function TimestampField(name) {
	        (0, _classCallCheck3.default)(this, TimestampField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (TimestampField.__proto__ || (0, _getPrototypeOf2.default)(TimestampField)).call(this, name));
	
	        _this._type = 'unixtime';
	        return _this;
	    }
	
	    return TimestampField;
	}(_DateTimeField3.default);
	
	module.exports = TimestampField;

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _Field2 = __webpack_require__(504);
	
	var _Field3 = _interopRequireDefault(_Field2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimestampField = function (_Field) {
	    (0, _inherits3.default)(TimestampField, _Field);
	
	    function TimestampField(name) {
	        (0, _classCallCheck3.default)(this, TimestampField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (TimestampField.__proto__ || (0, _getPrototypeOf2.default)(TimestampField)).call(this, name));
	
	        _this._type = 'datedict';
	        return _this;
	    }
	
	    return TimestampField;
	}(_Field3.default);
	
	module.exports = TimestampField;

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(907);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _BooleanField2 = __webpack_require__(561);
	
	var _BooleanField3 = _interopRequireDefault(_BooleanField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoolTimestampField = function (_BooleanField) {
	    (0, _inherits3.default)(BoolTimestampField, _BooleanField);
	
	    function BoolTimestampField(name) {
	        (0, _classCallCheck3.default)(this, BoolTimestampField);
	
	        var _this = (0, _possibleConstructorReturn3.default)(this, (BoolTimestampField.__proto__ || (0, _getPrototypeOf2.default)(BoolTimestampField)).call(this, name));
	
	        _this._type = 'bool_timestamp';
	        var ts = Date.parse(new Date()) / 1000;
	        _this._choices = [{ value: ts, label: 'true' }, { value: null, label: 'false' }];
	        _this._filterChoices = [{ value: ts, label: 'true' }, { value: null, label: 'false' }];
	        return _this;
	    }
	
	    (0, _createClass3.default)(BoolTimestampField, [{
	        key: 'attributes',
	        value: function attributes() {
	            return { value: Date.parse(new Date()) / 1000 };
	        }
	    }, {
	        key: 'getLabelForChoice',
	        value: function getLabelForChoice(value, entry) {
	            var choices = typeof this._choices === 'function' ? this._choices(entry) : this._choices;
	            var choice = choices.filter(function (c) {
	                return Boolean(c.value) == Boolean(value);
	            }).pop();
	            return choice ? choice.label : null;
	        }
	    }]);
	    return BoolTimestampField;
	}(_BooleanField3.default);
	
	module.exports = BoolTimestampField;

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ChoiceField2 = __webpack_require__(562);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var _countries = __webpack_require__(909);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountriesField = function (_ChoiceField) {
	    (0, _inherits3.default)(CountriesField, _ChoiceField);
	
	    function CountriesField(name) {
	        var _this;
	
	        (0, _classCallCheck3.default)(this, CountriesField);
	
	        (_this = (0, _possibleConstructorReturn3.default)(this, (CountriesField.__proto__ || (0, _getPrototypeOf2.default)(CountriesField)).call(this, name)), _this).choices(_countries2.default.alpha2().sortByName().toArray().map(function (el) {
	            return { value: '' + el.code, label: el.name };
	        }));
	        _this._type = "choices";
	        return _this;
	    }
	
	    return CountriesField;
	}(_ChoiceField3.default);
	
	module.exports = CountriesField;

/***/ }),

/***/ 915:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ChoiceField2 = __webpack_require__(562);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	var _countries = __webpack_require__(909);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CountriesField = function (_ChoiceField) {
	    (0, _inherits3.default)(CountriesField, _ChoiceField);
	
	    function CountriesField(name) {
	        var _this;
	
	        (0, _classCallCheck3.default)(this, CountriesField);
	
	        (_this = (0, _possibleConstructorReturn3.default)(this, (CountriesField.__proto__ || (0, _getPrototypeOf2.default)(CountriesField)).call(this, name)), _this).choices(_countries2.default.alpha2().sortByName().toArray().map(function (el) {
	            return { value: '' + el.code, label: el.name };
	        }));
	        _this._type = "choice";
	        return _this;
	    }
	
	    return CountriesField;
	}(_ChoiceField3.default);
	
	module.exports = CountriesField;

/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ChoiceField2 = __webpack_require__(562);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var languages = [{ "language": "Afar", "code": "aa" }, { "language": "Abkhazian", "code": "ab" }, { "language": "Afrikaans", "code": "af" }, { "language": "Akan", "code": "ak" }, { "language": "Amharic", "code": "am" }, { "language": "Aragonese", "code": "an" }, { "language": "Arabic", "code": "ar" }, { "language": "Assamese", "code": "as" }, { "language": "Avar", "code": "av" }, { "language": "Aymara", "code": "ay" }, { "language": "Azerbaijani", "code": "az" }, { "language": "Bashkir", "code": "ba" }, { "language": "Belarusian", "code": "be" }, { "language": "Bulgarian", "code": "bg" }, { "language": "Bihari", "code": "bh" }, { "language": "Bislama", "code": "bi" }, { "language": "Bambara", "code": "bm" }, { "language": "Bengali", "code": "bn" }, { "language": "Tibetan", "code": "bo" }, { "language": "Breton", "code": "br" }, { "language": "Bosnian", "code": "bs" }, { "language": "Catalan", "code": "ca" }, { "language": "Chechen", "code": "ce" }, { "language": "Chamorro", "code": "ch" }, { "language": "Corsican", "code": "co" }, { "language": "Cree", "code": "cr" }, { "language": "Czech", "code": "cs" }, { "language": "Old Church Slavonic / Old Bulgarian", "code": "cu" }, { "language": "Chuvash", "code": "cv" }, { "language": "Welsh", "code": "cy" }, { "language": "Danish", "code": "da" }, { "language": "German", "code": "de" }, { "language": "Divehi", "code": "dv" }, { "language": "Dzongkha", "code": "dz" }, { "language": "Ewe", "code": "ee" }, { "language": "Greek", "code": "el" }, { "language": "English", "code": "en" }, { "language": "Esperanto", "code": "eo" }, { "language": "Spanish", "code": "es" }, { "language": "Estonian", "code": "et" }, { "language": "Basque", "code": "eu" }, { "language": "Persian", "code": "fa" }, { "language": "Peul", "code": "ff" }, { "language": "Finnish", "code": "fi" }, { "language": "Fijian", "code": "fj" }, { "language": "Faroese", "code": "fo" }, { "language": "French", "code": "fr" }, { "language": "West Frisian", "code": "fy" }, { "language": "Irish", "code": "ga" }, { "language": "Scottish Gaelic", "code": "gd" }, { "language": "Galician", "code": "gl" }, { "language": "Guarani", "code": "gn" }, { "language": "Gujarati", "code": "gu" }, { "language": "Manx", "code": "gv" }, { "language": "Hausa", "code": "ha" }, { "language": "Hebrew", "code": "he" }, { "language": "Hindi", "code": "hi" }, { "language": "Hiri Motu", "code": "ho" }, { "language": "Croatian", "code": "hr" }, { "language": "Haitian", "code": "ht" }, { "language": "Hungarian", "code": "hu" }, { "language": "Armenian", "code": "hy" }, { "language": "Herero", "code": "hz" }, { "language": "Interlingua", "code": "ia" }, { "language": "Indonesian", "code": "id" }, { "language": "Interlingue", "code": "ie" }, { "language": "Igbo", "code": "ig" }, { "language": "Sichuan Yi", "code": "ii" }, { "language": "Inupiak", "code": "ik" }, { "language": "Ido", "code": "io" }, { "language": "Icelandic", "code": "is" }, { "language": "Italian", "code": "it" }, { "language": "Inuktitut", "code": "iu" }, { "language": "Japanese", "code": "ja" }, { "language": "Javanese", "code": "jv" }, { "language": "Kongo", "code": "kg" }, { "language": "Kikuyu", "code": "ki" }, { "language": "Kuanyama", "code": "kj" }, { "language": "Kazakh", "code": "kk" }, { "language": "Greenlandic", "code": "kl" }, { "language": "Cambodian", "code": "km" }, { "language": "Kannada", "code": "kn" }, { "language": "Korean", "code": "ko" }, { "language": "Kanuri", "code": "kr" }, { "language": "Kashmiri", "code": "ks" }, { "language": "Kurdish", "code": "ku" }, { "language": "Komi", "code": "kv" }, { "language": "Cornish", "code": "kw" }, { "language": "Kirghiz", "code": "ky" }, { "language": "Latin", "code": "la" }, { "language": "Luxembourgish", "code": "lb" }, { "language": "Ganda", "code": "lg" }, { "language": "Limburgian", "code": "li" }, { "language": "Lingala", "code": "ln" }, { "language": "Laotian", "code": "lo" }, { "language": "Lithuanian", "code": "lt" }, { "language": "Latvian", "code": "lv" }, { "language": "Malagasy", "code": "mg" }, { "language": "Marshallese", "code": "mh" }, { "language": "Maori", "code": "mi" }, { "language": "Macedonian", "code": "mk" }, { "language": "Malayalam", "code": "ml" }, { "language": "Mongolian", "code": "mn" }, { "language": "Moldovan", "code": "mo" }, { "language": "Marathi", "code": "mr" }, { "language": "Malay", "code": "ms" }, { "language": "Maltese", "code": "mt" }, { "language": "Burmese", "code": "my" }, { "language": "Nauruan", "code": "na" }, { "language": "North Ndebele", "code": "nd" }, { "language": "Nepali", "code": "ne" }, { "language": "Ndonga", "code": "ng" }, { "language": "Dutch", "code": "nl" }, { "language": "Norwegian Nynorsk", "code": "nn" }, { "language": "Norwegian", "code": "no" }, { "language": "South Ndebele", "code": "nr" }, { "language": "Navajo", "code": "nv" }, { "language": "Chichewa", "code": "ny" }, { "language": "Occitan", "code": "oc" }, { "language": "Ojibwa", "code": "oj" }, { "language": "Oromo", "code": "om" }, { "language": "Oriya", "code": "or" }, { "language": "Ossetian", "code": "os" }, { "language": "Punjabi", "code": "pa" }, { "language": "Pali", "code": "pi" }, { "language": "Polish", "code": "pl" }, { "language": "Pashto", "code": "ps" }, { "language": "Portuguese", "code": "pt" }, { "language": "Quechua", "code": "qu" }, { "language": "Raeto Romance", "code": "rm" }, { "language": "Kirundi", "code": "rn" }, { "language": "Romanian", "code": "ro" }, { "language": "Russian", "code": "ru" }, { "language": "Rwandi", "code": "rw" }, { "language": "Sanskrit", "code": "sa" }, { "language": "Sardinian", "code": "sc" }, { "language": "Sindhi", "code": "sd" }, { "language": "Sango", "code": "sg" }, { "language": "Serbo-Croatian", "code": "sh" }, { "language": "Sinhalese", "code": "si" }, { "language": "Slovak", "code": "sk" }, { "language": "Slovenian", "code": "sl" }, { "language": "Samoan", "code": "sm" }, { "language": "Shona", "code": "sn" }, { "language": "Somalia", "code": "so" }, { "language": "Albanian", "code": "sq" }, { "language": "Serbian", "code": "sr" }, { "language": "Swati", "code": "ss" }, { "language": "Southern Sotho", "code": "st" }, { "language": "Sundanese", "code": "su" }, { "language": "Swedish", "code": "sv" }, { "language": "Swahili", "code": "sw" }, { "language": "Tamil", "code": "ta" }, { "language": "Telugu", "code": "te" }, { "language": "Tajik", "code": "tg" }, { "language": "Thai", "code": "th" }, { "language": "Tigrinya", "code": "ti" }, { "language": "Turkmen", "code": "tk" }, { "language": "Tagalog", "code": "tl" }, { "language": "Tswana", "code": "tn" }, { "language": "Tonga", "code": "to" }, { "language": "Turkish", "code": "tr" }, { "language": "Tsonga", "code": "ts" }, { "language": "Tatar", "code": "tt" }, { "language": "Twi", "code": "tw" }, { "language": "Tahitian", "code": "ty" }, { "language": "Uyghur", "code": "ug" }, { "language": "Urdu", "code": "ur" }, { "language": "Venda", "code": "ve" }, { "language": "Vietnamese", "code": "vi" }, { "language": "Volapük", "code": "vo" }, { "language": "Walloon", "code": "wa" }, { "language": "Wolof", "code": "wo" }, { "language": "Xhosa", "code": "xh" }, { "language": "Yiddish", "code": "yi" }, { "language": "Yoruba", "code": "yo" }, { "language": "Zhuang", "code": "za" }, { "language": "Chinese", "code": "zh" }, { "language": "Zulu", "code": "zu" }];
	
	var LanguagesField = function (_ChoiceField) {
	    (0, _inherits3.default)(LanguagesField, _ChoiceField);
	
	    function LanguagesField(name) {
	        var _this;
	
	        (0, _classCallCheck3.default)(this, LanguagesField);
	
	        (_this = (0, _possibleConstructorReturn3.default)(this, (LanguagesField.__proto__ || (0, _getPrototypeOf2.default)(LanguagesField)).call(this, name)), _this).choices(languages.map(function (el) {
	            return { value: "" + el.code, label: el.language };
	        }));
	        _this._type = "choices";
	        return _this;
	    }
	
	    return LanguagesField;
	}(_ChoiceField3.default);
	
	module.exports = LanguagesField;

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ChoiceField2 = __webpack_require__(562);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var categories = [{ "label": "Automotive", value: 1 }, { "label": "BusinessNews", value: 2 }, { "label": "Celebrities", value: 3 }, { "label": "Classifieds", value: 4 }, { "label": "EmergencyServices", value: 5 }, { "label": "Entertainment", value: 6 }, { "label": "Food", value: 7 }, { "label": "Government", value: 8 }, { "label": "Lifestyle", value: 9 }, { "label": "Magazines", value: 10 }, { "label": "GeneralNews", value: 11 }, { "label": "OtherNonMedia", value: 12 }, { "label": "Politics", value: 13 }, { "label": "RadioStations", value: 14 }, { "label": "Sport", value: 15 }, { "label": "Style", value: 16 }, { "label": "Tabloids", value: 17 }, { "label": "Technology", value: 18 }, { "label": "Television", value: 19 }, { "label": "Travel", value: 20 }, { "label": "ViralNews", value: 21 }, { "label": "Culture", value: 22 }, { "label": "Science", value: 23 }, { "label": "Startups", value: 24 }, { "label": "Politicians", value: 25 }, { "label": "MediaIndustry", value: 26 }, { "label": "Health", value: 27 }, { "label": "SportTeams", value: 28 }, { "label": "Controversial", value: 29 }, { "label": "Satire", value: 30 }, { "label": "LGBT", value: 31 }];
	
	var CategoriesField = function (_ChoiceField) {
	    (0, _inherits3.default)(CategoriesField, _ChoiceField);
	
	    function CategoriesField(name) {
	        var _this;
	
	        (0, _classCallCheck3.default)(this, CategoriesField);
	
	        (_this = (0, _possibleConstructorReturn3.default)(this, (CategoriesField.__proto__ || (0, _getPrototypeOf2.default)(CategoriesField)).call(this, name)), _this).choices(categories);
	        _this._type = "choices";
	        return _this;
	    }
	
	    return CategoriesField;
	}(_ChoiceField3.default);
	
	module.exports = CategoriesField;

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _getPrototypeOf = __webpack_require__(513);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(902);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(903);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(904);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _ChoiceField2 = __webpack_require__(562);
	
	var _ChoiceField3 = _interopRequireDefault(_ChoiceField2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timezones = ['Africa/Abidjan', 'Africa/Accra', 'Africa/Addis_Ababa', 'Africa/Algiers', 'Africa/Asmara', 'Africa/Asmera', 'Africa/Bamako', 'Africa/Bangui', 'Africa/Banjul', 'Africa/Bissau', 'Africa/Blantyre', 'Africa/Brazzaville', 'Africa/Bujumbura', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/Conakry', 'Africa/Dakar', 'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Douala', 'Africa/El_Aaiun', 'Africa/Freetown', 'Africa/Gaborone', 'Africa/Harare', 'Africa/Johannesburg', 'Africa/Juba', 'Africa/Kampala', 'Africa/Khartoum', 'Africa/Kigali', 'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville', 'Africa/Lome', 'Africa/Luanda', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Malabo', 'Africa/Maputo', 'Africa/Maseru', 'Africa/Mbabane', 'Africa/Mogadishu', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Nouakchott', 'Africa/Ouagadougou', 'Africa/Porto-Novo', 'Africa/Sao_Tome', 'Africa/Timbuktu', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Adak', 'America/Anchorage', 'America/Anguilla', 'America/Antigua', 'America/Araguaina', 'America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/ComodRivadavia', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia', 'America/Aruba', 'America/Asuncion', 'America/Atikokan', 'America/Atka', 'America/Bahia', 'America/Bahia_Banderas', 'America/Barbados', 'America/Belem', 'America/Belize', 'America/Blanc-Sablon', 'America/Boa_Vista', 'America/Bogota', 'America/Boise', 'America/Buenos_Aires', 'America/Cambridge_Bay', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas', 'America/Catamarca', 'America/Cayenne', 'America/Cayman', 'America/Chicago', 'America/Chihuahua', 'America/Coral_Harbour', 'America/Cordoba', 'America/Costa_Rica', 'America/Creston', 'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson', 'America/Dawson_Creek', 'America/Denver', 'America/Detroit', 'America/Dominica', 'America/Edmonton', 'America/Eirunepe', 'America/El_Salvador', 'America/Ensenada', 'America/Fort_Nelson', 'America/Fort_Wayne', 'America/Fortaleza', 'America/Glace_Bay', 'America/Godthab', 'America/Goose_Bay', 'America/Grand_Turk', 'America/Grenada', 'America/Guadeloupe', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Indianapolis', 'America/Inuvik', 'America/Iqaluit', 'America/Jamaica', 'America/Jujuy', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Knox_IN', 'America/Kralendijk', 'America/La_Paz', 'America/Lima', 'America/Los_Angeles', 'America/Louisville', 'America/Lower_Princes', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Marigot', 'America/Martinique', 'America/Matamoros', 'America/Mazatlan', 'America/Mendoza', 'America/Menominee', 'America/Merida', 'America/Metlakatla', 'America/Mexico_City', 'America/Miquelon', 'America/Moncton', 'America/Monterrey', 'America/Montevideo', 'America/Montreal', 'America/Montserrat', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Nome', 'America/Noronha', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Ojinaga', 'America/Panama', 'America/Pangnirtung', 'America/Paramaribo', 'America/Phoenix', 'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Acre', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Punta_Arenas', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Recife', 'America/Regina', 'America/Resolute', 'America/Rio_Branco', 'America/Rosario', 'America/Santa_Isabel', 'America/Santarem', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund', 'America/Shiprock', 'America/Sitka', 'America/St_Barthelemy', 'America/St_Johns', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent', 'America/Swift_Current', 'America/Tegucigalpa', 'America/Thule', 'America/Thunder_Bay', 'America/Tijuana', 'America/Toronto', 'America/Tortola', 'America/Vancouver', 'America/Virgin', 'America/Whitehorse', 'America/Winnipeg', 'America/Yakutat', 'America/Yellowknife', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Macquarie', 'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/South_Pole', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok', 'Arctic/Longyearbyen', 'Asia/Aden', 'Asia/Almaty', 'Asia/Amman', 'Asia/Anadyr', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Ashkhabad', 'Asia/Atyrau', 'Asia/Baghdad', 'Asia/Bahrain', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Barnaul', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Calcutta', 'Asia/Chita', 'Asia/Choibalsan', 'Asia/Chongqing', 'Asia/Chungking', 'Asia/Colombo', 'Asia/Dacca', 'Asia/Damascus', 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Harbin', 'Asia/Hebron', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Istanbul', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Kashgar', 'Asia/Kathmandu', 'Asia/Katmandu', 'Asia/Khandyga', 'Asia/Kolkata', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Kuching', 'Asia/Kuwait', 'Asia/Macao', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Muscat', 'Asia/Nicosia', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Oral', 'Asia/Phnom_Penh', 'Asia/Pontianak', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Qostanay', 'Asia/Qyzylorda', 'Asia/Rangoon', 'Asia/Riyadh', 'Asia/Saigon', 'Asia/Sakhalin', 'Asia/Samarkand', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Srednekolymsk', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Tel_Aviv', 'Asia/Thimbu', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Tomsk', 'Asia/Ujung_Pandang', 'Asia/Ulaanbaatar', 'Asia/Ulan_Bator', 'Asia/Urumqi', 'Asia/Ust-Nera', 'Asia/Vientiane', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yangon', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faeroe', 'Atlantic/Faroe', 'Atlantic/Jan_Mayen', 'Atlantic/Madeira', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/St_Helena', 'Atlantic/Stanley', 'Australia/ACT', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Canberra', 'Australia/Currie', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/LHI', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/NSW', 'Australia/North', 'Australia/Perth', 'Australia/Queensland', 'Australia/South', 'Australia/Sydney', 'Australia/Tasmania', 'Australia/Victoria', 'Australia/West', 'Australia/Yancowinna', 'Brazil/Acre', 'Brazil/DeNoronha', 'Brazil/East', 'Brazil/West', 'CET', 'CST6CDT', 'Canada/Atlantic', 'Canada/Central', 'Canada/Eastern', 'Canada/Mountain', 'Canada/Newfoundland', 'Canada/Pacific', 'Canada/Saskatchewan', 'Canada/Yukon', 'Chile/Continental', 'Chile/EasterIsland', 'Cuba', 'EET', 'EST', 'EST5EDT', 'Egypt', 'Eire', 'Etc/GMT', 'Etc/GMT+0', 'Etc/GMT+1', 'Etc/GMT+10', 'Etc/GMT+11', 'Etc/GMT+12', 'Etc/GMT+2', 'Etc/GMT+3', 'Etc/GMT+4', 'Etc/GMT+5', 'Etc/GMT+6', 'Etc/GMT+7', 'Etc/GMT+8', 'Etc/GMT+9', 'Etc/GMT-0', 'Etc/GMT-1', 'Etc/GMT-10', 'Etc/GMT-11', 'Etc/GMT-12', 'Etc/GMT-13', 'Etc/GMT-14', 'Etc/GMT-2', 'Etc/GMT-3', 'Etc/GMT-4', 'Etc/GMT-5', 'Etc/GMT-6', 'Etc/GMT-7', 'Etc/GMT-8', 'Etc/GMT-9', 'Etc/GMT0', 'Etc/Greenwich', 'Etc/UCT', 'Etc/UTC', 'Etc/Universal', 'Etc/Zulu', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Astrakhan', 'Europe/Athens', 'Europe/Belfast', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Busingen', 'Europe/Chisinau', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Guernsey', 'Europe/Helsinki', 'Europe/Isle_of_Man', 'Europe/Istanbul', 'Europe/Jersey', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Kirov', 'Europe/Lisbon', 'Europe/Ljubljana', 'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Mariehamn', 'Europe/Minsk', 'Europe/Monaco', 'Europe/Moscow', 'Europe/Nicosia', 'Europe/Oslo', 'Europe/Paris', 'Europe/Podgorica', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/San_Marino', 'Europe/Sarajevo', 'Europe/Saratov', 'Europe/Simferopol', 'Europe/Skopje', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Tirane', 'Europe/Tiraspol', 'Europe/Ulyanovsk', 'Europe/Uzhgorod', 'Europe/Vaduz', 'Europe/Vatican', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Volgograd', 'Europe/Warsaw', 'Europe/Zagreb', 'Europe/Zaporozhye', 'Europe/Zurich', 'GB', 'GB-Eire', 'GMT', 'GMT+0', 'GMT-0', 'GMT0', 'Greenwich', 'HST', 'Hongkong', 'Iceland', 'Indian/Antananarivo', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Comoro', 'Indian/Kerguelen', 'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Mayotte', 'Indian/Reunion', 'Iran', 'Israel', 'Jamaica', 'Japan', 'Kwajalein', 'Libya', 'MET', 'MST', 'MST7MDT', 'Mexico/BajaNorte', 'Mexico/BajaSur', 'Mexico/General', 'NZ', 'NZ-CHAT', 'Navajo', 'PRC', 'PST8PDT', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Bougainville', 'Pacific/Chatham', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Johnston', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Midway', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Ponape', 'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Saipan', 'Pacific/Samoa', 'Pacific/Tahiti', 'Pacific/Tarawa', 'Pacific/Tongatapu', 'Pacific/Truk', 'Pacific/Wake', 'Pacific/Wallis', 'Pacific/Yap', 'Poland', 'Portugal', 'ROC', 'ROK', 'Singapore', 'Turkey', 'UCT', 'US/Alaska', 'US/Aleutian', 'US/Arizona', 'US/Central', 'US/East-Indiana', 'US/Eastern', 'US/Hawaii', 'US/Indiana-Starke', 'US/Michigan', 'US/Mountain', 'US/Pacific', 'US/Samoa', 'UTC', 'Universal', 'W-SU', 'WET', 'Zulu'];
	
	var TimezonesField = function (_ChoiceField) {
	    (0, _inherits3.default)(TimezonesField, _ChoiceField);
	
	    function TimezonesField(name) {
	        var _this;
	
	        (0, _classCallCheck3.default)(this, TimezonesField);
	
	        (_this = (0, _possibleConstructorReturn3.default)(this, (TimezonesField.__proto__ || (0, _getPrototypeOf2.default)(TimezonesField)).call(this, name)), _this).choices(timezones.map(function (el) {
	            return { value: el, label: el };
	        }));
	        return _this;
	    }
	
	    return TimezonesField;
	}(_ChoiceField3.default);
	
	module.exports = TimezonesField;

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    getReadWidget: function getReadWidget() {
	        return '<span>{{(value ? value*1000: value)|date:"M/d/yy H:mm"}}</span>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};

/***/ }),

/***/ 920:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    getReadWidget: function getReadWidget() {
	        return '<span>{{value.year}}-{{value.month}}-{{JSON.stringify(value)}}-</span>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ma-date-field field="::field" value="value"></ma-date-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<div class="datetime_widget"><ma-date-field field="::field" value="value"></ma-date-field></div>';
	    }
	};

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	    getReadWidget: function getReadWidget() {
	        return '<ma-boolean-column value="::value"></ma-boolean-column>';
	    },
	    getLinkWidget: function getLinkWidget() {
	        return '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>';
	    },
	    getFilterWidget: function getFilterWidget() {
	        return '<ezy-bool-timestamp-field field="::field" value="value" choices="::field.filterChoices()"></ezy-bool-timestamp-field>';
	    },
	    getWriteWidget: function getWriteWidget() {
	        return '<ezy-bool-timestamp-field class="col-sm-6 col-md-6" field="::field" entry="entry" ng-if="true" value="$parent.value"></ezy-bool-timestamp-field>';
	    }
	};

/***/ })

});


// WEBPACK FOOTER //
// app.bundle.js